import Hideable, { Hide, Show } from '../../../../../../../interface/Hideable.js';
import { makeStruct } from '../../../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../../../enums/ModelData.js';
import SPAN from '../../../../../../DOM/span/SPAN.js';
// Model Structure
export const formFieldAttr = makeAttrStruct([
    ['type'],
    ['name']
]);
export const formFieldData = makeDataStruct([
    ['text', '']
]);
export const formFieldModel = makeStruct([
    ['attributes', formFieldAttr],
    ['data', formFieldData]
]);
// Simplified Model
export function formFieldMessage(text, type, name) {
    return {
        attributes: formFieldAttr(type, name),
        data: formFieldData(text)
    };
}
// Class
export default class FORMFIELDMESSAGE extends SPAN {
    /** Constructs a Form Element */
    type;
    constructor(node, model) {
        super(node, model);
        this.addClass('form-field-message');
        this.implement(new Hideable(this));
        this.type = model.attributes.type;
    }
    getType() {
        return this.type;
    }
    setType(type) {
        this.type = type;
        this.model.attributes.type = type;
        return this;
    }
}
export { Hide, Show };
